import React, {useMemo} from 'react';
import {usePassMasterData} from "../../logs/useTableData";
import TablePage from "../../../pages/tablePage/TablePage";
import ErrorPage from "../../../shared/components/ErrorPage";
import {PassMasterTableEntity} from "./PassMasterTableEntity";
import {Button} from "antd";
import {internalApi} from "../../../common/axios";
import toast from "react-hot-toast";
import IsLoading from "../../../shared/components/IsLoading";
import {PassMasterEntity} from "./PassMasterEntity";
import {savePassMaster} from "./usePassMaster";

const PASS_TYPE_DATA = {
    1: {
        name: '월간 패스',
        color: '#e6f7ff',
    },
    2: {
        name: '주간 패스',
        color: '#fffbe6',
    }
}

const PassTable = () => {
    const {data: passMaster, isLoading: isPassMasterLoading, error: passMasterError} = usePassMasterData();

    const handleSave = async (record) => {
        const row = new PassMasterEntity(record);
        if (row.isInvalidate()) return;
        await savePassMaster(row.toJson());
    }

    const columns = useMemo(() => [
        {
            title: '패스 타입',
            dataIndex: 'passType',
            key: 'passType',
            sorter: (a, b) => a.passType - b.passType,
            render: (_, {passType}) => (
                <span style={{
                    backgroundColor: PASS_TYPE_DATA[passType].color || '#f5f5f5',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    display: 'inline-block',
                }}>
                    {PASS_TYPE_DATA[passType].name || '알 수 없음'}
                </span>
            )
        },
        {
            title: '인덱스',
            dataIndex: 'index',
            key: 'index',
            sorter: (a, b) => a.index - b.index,
        },
        {
            title: '패스 이름',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '액션',
            render: (record) => (
                <Button onClick={() => handleSave(record)}>
                    {'추가하기'}
                </Button>
            )
        }
    ], []);

    if (isPassMasterLoading) return <IsLoading/>;
    if (passMasterError) return <ErrorPage error={passMasterError}/>;

    const props = {
        columns,
        isLoading: isPassMasterLoading,
        localData: passMaster || [],
        entityModel: PassMasterTableEntity,
    }

    return (
        <TablePage
            {...props}
        />
    );
};

export default PassTable;